import styled from '@emotion/styled'

export const EstimateComparePageStyled = styled.div`
  label: EstimateComparePageStyled;
    .estimate-list {
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      position: relative;
      top: 32px;
      margin-bottom: 40px;
      .react-multiple-carousel__arrow {
        top: 200px;
      }
      .react-multi-carousel-list {
        margin-top: 24px;
        padding: 0;
      }
    }
    .navigators.estimate-list .react-multiple-carousel__arrow {
      @media screen and (min-width: ${(props) => props.theme.mq.xl}) {
        display: none;
      }
    }
  }
`

export const EstimateItemWrapper = styled.div`
  label: EstimateItemWrapper;
  display: flex;
  justify-content: center;
  height: 100%;
`
